module.exports = __webpack_public_path__ + "img/media (13).c8b937b5.png";